import React from 'react'
import LayoutSupportDocument from "./layout/LayoutSupportDocument";

export default function SupportDocumentScreen() {
    return (
        <LayoutSupportDocument />
    )
}
